import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { useMemo } from "react";
import { ChevronDownIcon } from "../icons/ChevronDownIcon";

interface IProps {
  selectedKeys: Set<string>;
  onSelectionChange: (keys: Set<string>) => void;
  dropdownItems: {
    id: number;
    type: string;
    name: string;
    _count: { textContent: number };
  }[];
}

function DropDown(props: IProps) {
  const selectedValue = useMemo(
    () => Array.from(props.selectedKeys).join(", ").replaceAll("_", " "),
    [props.selectedKeys]
  );

  return (
    <div>
      <Dropdown placement="bottom-start">
        <DropdownTrigger>
          <Button
            className=" capitalize bg-[#888] text-[16px] font-normal
             text-white !p-0 transition-transform duration-300 ease-in-out !px-3"
            radius="full"
          >
            <div className="flex items-center gap-2 px-3">
              {selectedValue} <ChevronDownIcon size={16} />
            </div>
          </Button>
        </DropdownTrigger>
        <DropdownMenu
          //@ts-ignore
          onSelectionChange={props.onSelectionChange}
          disallowEmptySelection
          selectionMode="single"
          aria-label="Profile Actions"
          variant="flat"
          selectedKeys={props.selectedKeys}
        >
          {props.dropdownItems.filter(item => item.type !== "airport-transfer" && item.type !== "news" && item.type !== "esim" && item.type !== "insurance").map((item) => {
            return (
              <DropdownItem key={item.type}>{item.name}</DropdownItem>
            )
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default DropDown;
